import { Box, CircularProgress } from '@mui/material';

import { useAuth, authStatus } from '../../context/auth/AuthContext';

const AuthGate = ({ children }) => {
  const { status } = useAuth();

  if (status === authStatus.LOADING) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

export default AuthGate;
